<div class="login-form">
	<h4 class="login-heading">Welcome back</h4>
	<p class="login-subline">Enter your password to continue</p>
	<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mb-3">
		<div class="alert alert-danger" *ngIf="message">
			{{message}}
		</div>
		<div class="form-floating-underline mb-4" [ngClass]="{'active': form.get('username')?.value}">
			<input
				formControlName="username"
				name="username"
				type="text"
				id="usernameInput"
				placeholder=" "
				autocomplete="username"
				required
				readonly/>
			<label for="usernameInput">Username</label>
		</div>
		<div class="form-floating-underline mb-4" [ngClass]="{'active': form.get('password')?.value}">
			<input
				formControlName="password"
				appAutoFocus
				name="password"
				[type]="showPassword ? 'text' : 'password'"
				id="passwordInput"
				placeholder=" "
				autocomplete="password"
				required/>
			<label for="passwordInput">Password</label>
			<a class="text-secondary text-decoration-none position-absolute end-0 pw-toggle me-3" (click)="showPassword = !showPassword">
				<i *ngIf="showPassword"  nz-icon nzType="eye" nzTheme="outline" style="font-size: 1.3em"></i>
				<i *ngIf="!showPassword" nz-icon nzType="eye-invisible" nzTheme="outline" style="font-size: 1.3em"></i>
			</a>
		</div>
		<div class="btn-group w-100 mt-3">
			<a class="btn btn-outline-secondary" (click)="reset()">Back</a>
			<button class="w-75 btn btn-primary login-submit" type="submit" [disabled]="form.invalid" *ngIf="submitting == false">Sign In</button>
			<button class="w-75 btn btn-primary login-submit" type="submit" [disabled]="true" *ngIf="submitting == true">
				<i nz-icon nzType="loading" nzTheme="outline"></i>
			</button>
		</div>
		<div class="login-help">
			<span>Step 1 of 2</span>
			<a class="link" (click)="showForgotPassword()">Forgot password?</a>
		</div>
	</form>
</div>
